import React, { Component } from 'react';

class ExperienceComponent extends Component {
    render() {
        return (
            <li className="experience">
                <span>{this.props.date}</span>
                <ul className="experience-details">
                    <li className="company">{this.props.company}</li>
                    <li className="position">{this.props.position}</li>
                </ul>
            </li>
        );
    }
}

export default ExperienceComponent;



// WEBPACK FOOTER //
// ./src/components/experience/experience.component.jsx